import { render, staticRenderFns } from "./MassDisableSasvModal.vue?vue&type=template&id=48bc4570"
import script from "./MassDisableSasvModal.vue?vue&type=script&lang=js"
export * from "./MassDisableSasvModal.vue?vue&type=script&lang=js"
import style0 from "./MassDisableSasvModal.vue?vue&type=style&index=0&id=48bc4570&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports